import React from 'react';
import ReactDOM from 'react-dom/client';

import store from './store';
import history from './history';
import Root from './components/Root';

import './i18n';
// FAMILY-EXT: тёмная тема в коричневых тонах (опт-ин через переключатель в Header)
import './family-theme.scss';
import './utils/family-theme';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(React.createElement(Root, { store, history }));
